<!--
 * @Author: Suroc
 * @Date: 2024-07-09 10:19:06
 * @LastEditTime: 2024-12-27 15:06:08
 * @Description: 公共消息提示窗口
-->
<template>
  <transition name="surocPrompt">
    <div class="surocPrompt" :class="themeClass" v-if="flagMask">
      <div v-if="
        settingMask == 'pledgeSuccess' ||
        settingMask == 'pledgefailed' ||
        settingMask == 'notYetDev' ||
        settingMask == 'signSuccess'
      " class="promptCard">
        <img @click="closePrompt()" class="closeCard" src="@/assets/prompt/5.png" />
        <img src="@/assets/prompt/1.png" v-if="settingMask == 'pledgeSuccess'" />
        <img src="@/assets/prompt/2.png" v-else-if="settingMask == 'pledgefailed'" />
        <img class="imgPrompt" src="@/assets/prompt/3.png" v-else-if="settingMask == 'notYetDev'" />
        <p v-if="settingMask == 'pledgeSuccess'">{{ getOptions.errInfo }}</p>
        <p v-else-if="settingMask == 'pledgefailed'">{{ getOptions.errInfo }}<br v-if="getOptions.info" />{{
          getOptions.info ? getOptions.info : '' }} </p>
        <p v-else-if="settingMask == 'notYetDev'">{{ $t('Prompt.NotYetDev') }}</p>
        <p v-else-if="settingMask == 'signSuccess'">{{ getOptions.errInfo }}</p>
        <div class="func">
          <el-button @click="closePrompt()">{{ $t('Prompt.Confirm') }}</el-button>
        </div>
      </div>
      <div v-if="settingMask == 'handProfit'" class="profitCard">
        <img src="@/assets/prompt/2.png" />
        <p>{{ getOptions.errInfo }}</p>
        <div class="func">
          <el-button @click="goToProfit('/profit')">{{ $t('Prompt.GoGetIt') }}</el-button>
          <el-button @click="closePrompt()">{{ $t('Prompt.Cancel') }}</el-button>
        </div>
      </div>
      <!-- 等待中 -->
      <div v-if="settingMask == 'loading'" class="loadCard">
        <div class="logo wow animate__animated animate__shakeY" data-wow-iteration="infinite" data-wow-duration="12s">
        </div>
        <p class="text wow animate__animated animate__tada" data-wow-iteration="infinite" data-wow-duration="2.5s">
          {{ $t('common.czzqsh') }}
        </p>
      </div>
      <!-- 绑定邀请 -->
      <div v-if="settingMask == 'Invite'" class="promptCard inviteCard">
        <img @click="closePrompt()" class="closeCard" src="@/assets/prompt/5.png" />
        <img src="@/assets/prompt/1.png" />
        <p>
          {{ $t('Prompt.InviteInfo1') }}{{ $Tool.maskAccount(InviteID, 4)
          }}{{ $t('Prompt.InviteInfo2') }}
        </p>
        <div class="func">
          <el-button class="promptBut" @click="sendInvite()">{{ $t('Prompt.Confirm') }}</el-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import WOW from 'wow.js'
import { userMaskStore } from '@/stores/settings'
import { userWalletStore } from '@/stores/qmx/user'
import { useRouter } from 'vue-router'
const router = useRouter()
const maskStore = userMaskStore()
let walletStore = userWalletStore()
const flagMask = computed(() => maskStore.isMaskVisible)
const settingMask = computed(() => maskStore.maskType)
let drwaDot = computed(() => maskStore.drwadot)
let getOptions = computed(() => maskStore.setOptions)
let InviteID = computed(() => walletStore.inviteId)
let userAccount = computed(() => walletStore.account)

let drawaRadio = ref(16)
let isMarkTolerance = ref(false)

watch(isMarkTolerance, (newVal) => {
  if (newVal) drawaRadio.value = drwaDot.value
})

onMounted(() => {
  var offsetValue = window.innerHeight > 800 ? 0 : 30 // 基于屏幕高度调整
  new WOW({
    boxClass: 'wow',
    animateClass: 'animated',
    offset: offsetValue,
    mobile: true,
    live: true,
    callback: () => { },
    scrollContainer: '.signinView',
    resetAnimation: true
  }).init()
})

/**
 * @description 绑定邀请人
 * @param {ID} 邀请者ID
 */
let sendInvite = async (ID) => {
  try {
    maskStore.showMask(true, 'loading')
    let receipt = await contract.methods
      .bind(userAccount.value, InviteID.value)
      .send({ from: userAccount.value })
    if (receipt) {
      maskStore.showMask(true, 'pledgeSuccess', {
        errInfo: 'BindingSucceeded'
      })
    } else {
      maskStore.showMask(true, 'pledgefailed', {
        errInfo: 'BindingFailed'
      })
    }
  } catch (error) {
    maskStore.showMask(true, 'pledgefailed', {
      errInfo: 'BindingFailed'
    })
  }
}
/**
 * @description 去领取收益
 * @param {path}  切换的路径
 */
const goToProfit = (path) => {
  maskStore.showMask(false)
  router.push(path)
}
let closePrompt = (val) => {
  maskStore.showMask(false)
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
